import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { AlertDto } from '@/Domain/api/Conversation/dto/Alert.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export type AlertCreateInput = Pick<AlertDto, 'name' | 'description'> &
  Partial<Pick<AlertDto, 'is_active' | 'run_conditions'>>;

export type AlertUpdateInput = Pick<AlertDto, 'id'> & Partial<Omit<AlertDto, 'id'>>;

export class ConversationAnalysisAlertsApi {
  static list = (): Promise<AlertDto[]> =>
    httpClient.get(Endpoint.conversationAnalysisAlerts.list).then(ApiMapper.toResponseData);

  static get = (alertId: number): Promise<AlertDto> =>
    httpClient
      .get(Endpoint.conversationAnalysisAlerts.get.replace(':alertId', String(alertId)))
      .then(ApiMapper.toResponseData);

  static create = (alert: AlertCreateInput): Promise<AlertDto> =>
    httpClient
      .post(Endpoint.conversationAnalysisAlerts.create, alert)
      .then(ApiMapper.toResponseData);

  static update = ({ id, ...alert }: AlertUpdateInput): Promise<AlertDto> =>
    httpClient
      .patch(Endpoint.conversationAnalysisAlerts.update.replace(':alertId', String(id)), alert)
      .then(ApiMapper.toResponseData);

  static remove = (alertId: number): Promise<void> =>
    httpClient
      .delete(Endpoint.conversationAnalysisAlerts.delete.replace(':alertId', String(alertId)))
      .then(ApiMapper.toResponseData);
}
